<template>
  <div>
    <PageTable
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      :multiple="multiple"
      @reload="reload"
      @choose-change="(r) => $emit('choose-change', r)"
    >
      <PageHeader
        slot="header"
        ref="header"
        @query="getData"
        @reset="resetPage"
      />
      <pagination
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageTable>
  </div>
</template>

<script>
import PageHeader from './header.vue'
import PageTable from './table.vue'
import BaseTable from '@/mixins/base-table'
export default {
  components: { PageHeader, PageTable },
  mixins: [BaseTable],
  props: {
    extrasParams: { type: Object, default: () => ({}) },
    multiple: { type: Boolean, default: false },
  },
  data() {
    return { usePage: true }
  },
  methods: {
    getData(form) {
      this.loading = true
      this.$api
        .masterFabricChooseListApi({
          ...form,
          ...this.page,
          ...this.extrasParams,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
